import React from "react";
import { MDBAnimation, MDBCard, MDBCardBody } from "mdbreact";

import Header from "./header";
import Body from "./collapse";
import Footer from "./footer";
import TableLoading from "../../../../../components/tableLoading";
import { useSelector } from "react-redux";

const Index = () => {
  const { isLoading } = useSelector(({ deals }) => deals);
  return (
    <MDBAnimation type="bounceInDown">
      <MDBCard narrow className="pb-3" style={{ minHeight: "600px" }}>
        <Header />
        <MDBCardBody>{isLoading ? <TableLoading /> : <Body />}</MDBCardBody>
        <Footer />
      </MDBCard>
    </MDBAnimation>
  );
};

export default Index;
